import { render, staticRenderFns } from "./expire.vue?vue&type=template&id=5e64de85&scoped=true&"
import script from "./expire.vue?vue&type=script&lang=js&"
export * from "./expire.vue?vue&type=script&lang=js&"
import style0 from "./expire.vue?vue&type=style&index=0&id=5e64de85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e64de85",
  null
  
)

export default component.exports